<template>
  <div class="circle-timer" :style="{ width: size + 'px', height: size + 'px' }">
    <svg :viewBox="`0 0 ${viewBoxSize} ${viewBoxSize}`" class="timer-svg">
      <circle 
        :cx="center" 
        :cy="center" 
        :r="radius" 
        class="timer-circle-bg"
        :style="{
          stroke: backgroundColor,
          strokeWidth: strokeWidth
        }"
      />
      <circle 
        :cx="center" 
        :cy="center" 
        :r="radius" 
        class="timer-circle" 
        ref="progressCircle"
        :style="circleStyle"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'CircleTimer',
  
  props: {
    // 组件大小 (px)
    size: {
      type: Number,
      default: 32
    },
    // 动画时间 (ms)
    duration: {
      type: Number,
      default: 10000
    },
    // 进度条颜色
    primaryColor: {
      type: String,
      default: '#fff'
    },
    // 背景颜色
    backgroundColor: {
      type: String,
      default: 'rgba(255, 255, 255, 0.3)'
    },
    // 线条宽度
    strokeWidth: {
      type: String,
      default: '2px'
    }
  },
  
  data() {
    return {
      progress: 0  // 简化进度控制
    }
  },
  
  computed: {
    // SVG 视口大小
    viewBoxSize() {
      return Math.ceil(this.size * 1.5)
    },
    
    // SVG 圆心坐标
    center() {
      return this.viewBoxSize / 2
    },
    
    // 圆环半径
    radius() {
      return this.viewBoxSize / 3
    },
    
    // 圆周长度
    circumference() {
      return 2 * Math.PI * this.radius
    },
    
    // 圆环样式
    circleStyle() {
      return {
        stroke: this.primaryColor,
        strokeWidth: this.strokeWidth,
        strokeDasharray: this.circumference,
        strokeDashoffset: this.circumference,
        transition: `stroke-dashoffset ${this.duration}ms linear`
      }
    }
  },
  
  mounted() {
    // 使用纯 CSS 动画，无需 JS 控制
    this.$nextTick(() => {
      this.progress = 1
      this.$refs.progressCircle.style.strokeDashoffset = 0
    })
  },

  methods: {
    start() {
      this.$refs.progressCircle.style.strokeDashoffset = this.circumference
      this.$nextTick(() => {
        this.$refs.progressCircle.style.strokeDashoffset = 0
      })
    },
    
    reset() {
      this.$refs.progressCircle.style.strokeDashoffset = this.circumference
    }
  }
}
</script>

<style scoped>
.circle-timer {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.timer-svg {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.timer-circle-bg {
  fill: none;
}

.timer-circle {
  fill: none;
  stroke-linecap: round;
}
</style>